import * as React from 'react'

class MdPaginate extends React.Component<MdPaginateProps, null> {

  constructor(props: any) {
    super(props)
  }
  public selectPage(page, e) {
    e.preventDefault()
    this.props.onSelectPage(page)
  }

  private addPages(s, f) {
    return Array(f - s).fill(null).map((obj, key) => {
      let page = key + s
      return (
      <li className={(this.props.currentPage === page ? 'active' : '')}>
      <a key={key} onClick={(e) => { this.selectPage(page, e) }}>{page}</a></li>)
    })
  }

  private lastPage() {
    return [(<li>...</li>), (
      <li className={(this.props.currentPage === this.props.totalPages ? 'active' : '')}>
        <a
          onClick={(e) => { this.selectPage(this.props.totalPages, e) }}>
          {this.props.totalPages}
        </a>
      </li>
    )]
  }

  private firstPage() {
    return [
    (<li className={(this.props.currentPage === 1 ? 'active' : '')}><a onClick={(e) => { this.selectPage(1, e) }}>1</a></li>),
    (<li>...</li>)]
  }

  private prev(e) {
    e.preventDefault()
    this.props.onSelectPage(Math.max(this.props.currentPage - 1, 1))
  }

  private next(e) {
    e.preventDefault()
    this.props.onSelectPage(Math.min(this.props.currentPage + 1, this.props.totalPages))
  }

  private populate() {
    let size = this.props.totalPages
    let step = this.props.pageStep
    let page = this.props.currentPage

    if (size < step * 2 + 6) {
      return [this.addPages(1, size + 1)]
    } else if (page < step * 2 + 1) {
      return [this.addPages(1, step * 2 + 4), this.lastPage()]
    } else if (page > size - step * 2) {
      return [this.firstPage(), this.addPages(size - step * 2 - 2, size + 1)]
    } else {
       return [this.firstPage(), this.addPages(page - step, page + step + 1), this.lastPage()]
    }
  }

  public render() {
    let numPages = this.props.totalPages

    return (
      <div>
        {(numPages > 1) ? (
          <div className='md-paginate'>
            <ul>
              <li>
                <a onClick={(e) => { this.prev(e)}}>&laquo;</a>
              </li>
              {this.populate()}
             <li>
                <a onClick={(e) => { this.next(e)}}>&raquo;</a>
              </li>
             </ul>
          </div>
        ) : (null)}
      </div>
    )
  }
}

export default MdPaginate



// WEBPACK FOOTER //
// ./react/components/widgets/MdPaginate.tsx